import { HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationService } from '../service/validation.service';

@Component({
  selector: 'o3-post-payload',
  templateUrl: './post-payload.component.html',
  styleUrls: ['./post-payload.component.scss'],
})
export class PostPayloadComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  loading;
  payloadForm: FormGroup;
  result;
  constructor(private validationService: ValidationService) {}

  ngOnInit(): void {
    this.payloadForm = new FormGroup({
      reference: new FormControl('', Validators.required),
      payload: new FormControl('', Validators.required),
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  postPayload() {
    console.log(this.payloadForm.value);
    const post = this.payloadForm.value;
    this.result = '';
    this.subscriptions.add(
      this.validationService.postValidate(post).subscribe(
        (res: any) => {
          console.log(res);
          const formatResult = JSON.stringify(res, null, 2);
          this.result = formatResult;
        },
        (error) => {
          console.log(error);
          const formatResult = JSON.stringify(error, null, 2);
          this.result = formatResult;
        }
      )
    );
  }
}
